import { render, staticRenderFns } from "./SelectCoordinatesModal.vue?vue&type=template&id=70da7767"
import script from "./SelectCoordinatesModal.vue?vue&type=script&lang=ts"
export * from "./SelectCoordinatesModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports